import axios from 'axios';
import http from './http';
import docCookies from '@/utils/cookie';
import { md5 } from '@/utils/md5';

const cookieRefreshTokenKey = '.auth.refreshtoken';
const cookieTokenKey = '.auth.token';

export function removeRefreshToken() {
  return docCookies.removeItem(cookieRefreshTokenKey);
}
export function getRefreshToken() {
  return docCookies.getItem(cookieRefreshTokenKey);
}
export function setRefreshToken(token) {
  docCookies.setItem(cookieRefreshTokenKey, token);
}

export function removeAuthToken() {
  return docCookies.removeItem(cookieTokenKey);
}
export function getAuthToken() {
  return docCookies.getItem(cookieTokenKey);
}
export function setAuthToken(token) {
  docCookies.setItem(cookieTokenKey, token);
}

export function authorizeCode(code, redirect_uri) {
  const data = {
    grant_type: 'authorization_code',
    code,
    redirect_uri,
  };
  return getToken(data);
}
export function refreshToken(refresh_token) {
  const data = {
    grant_type: 'refresh_token',
    refresh_token,
  };
  return getToken(data);
}

function getToken(data) {
  var auth_token = getAuthToken();
  if (auth_token && data.grant_type === 'refresh_token') {
    data.access_token = auth_token.substring(7);
  }

  data.client_id = 'web';
  data.timestamp = parseInt(new Date().getTime() / 1000);
  data.client_secret = getSecret(data.timestamp);
  return axios
    .post(window.ENV_CFG.token, data)
    .then(res => {
      if (res.data?.access_token) {
        http.setAuthorization(res.data);
        setAuthToken(res.data.token_type + ' ' + res.data.access_token);
        setRefreshToken(res.data.refresh_token);
        return Promise.resolve(res.data);
      } else {
        removeRefreshToken();
        return Promise.reject(res);
      }
    })
    .catch(e => {
      removeRefreshToken();
      return Promise.reject(e);
    });
}

function getSecret(timestamp) {
  const hash = md5('8UR7J1cm0fpWTSCz' + timestamp);
  return hash.slice(8, 16 + (timestamp % 16));
}
